
import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionManagementService } from './session-management.service';
import { PendoService } from '../../Common/Misc/services/pendo.service';

// Interceptor will throw this error when a 401 is encountered.
// This may be caught be the caller, but if it is not, it will
// eventually bubble up to this service, which will perform the login redirect
export class AuthenticationError extends Error {}


@Injectable()
export class ErrorHandlerService implements ErrorHandler {

    constructor(
        private sessionManagementService: SessionManagementService,
        private pendoService: PendoService,
        private router: Router
    ) {
    }

    public handleError(error: Error) {
        if (error instanceof AuthenticationError) {
            const urlParse: RegExp = /PasswordReset|Login|login|ForgotPassword|MultiFactorAuthentication/;
            let currentPath = this.router.routerState.snapshot.url;
            if (currentPath === '') {
                // router state is not yet set, it is not reliable, we will use window.location.pathname instead
                currentPath = window.location.pathname;
            }
            const matches = currentPath.match(urlParse);
            if (!matches) {
                this.sessionManagementService.handleLogOut();
            }
        } else if (error?.message?.indexOf('Error: Cannot match any routes.') !== -1) {
            // Unmatched route error, do not need to log it
        } else {
            try {
                this.pendoService.trackEvent({
                    type: 'UNHANDLED_ERROR',
                    data: {
                        m: error?.message?.substring(0, 220),
                        s: error?.stack?.substring(0, 220)
                    }
                });
            } catch (err) {
                // Don't get caught in a loop of reporting errors...
                console.error(err);
            }
            console.error(error);
        }
    }
}
